import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { saveRedirectPath } from '../utils/redirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  fallbackPath?: string;
  requireAuth?: boolean; // If true, redirect to login. If false, redirect to dashboard
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  isAuthenticated,
  fallbackPath = '/login',
  requireAuth = true,
}) => {
  const location = useLocation();

  if (!isAuthenticated) {
    if (requireAuth) {
      // Save the current path before redirecting to login
      console.log(
        'ProtectedRoute - saving path:',
        location.pathname + location.search
      );
      saveRedirectPath(location.pathname + location.search);
      return <Navigate to={fallbackPath} replace />;
    } else {
      // User is not authenticated but this route doesn't require auth
      // Redirect to dashboard instead
      return <Navigate to='/dashboard' replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
